import { createFileRoute } from "@tanstack/react-router";
import { TabOne } from "@/views/showcase/tabs/TabOne.tsx";
import { Box, Link, Tab } from "@mui/material";
import type { ReactNode } from "react";
import { AppTabList } from "@/components/AppTabList";

export type TabType = {
  label: string;
  value: string;
  href: string;
  children: ReactNode;
};

export const Route = createFileRoute("/_dashboard/showcase/tabs/$tab")({
  component: TabsShowcase,
});

function TabsShowcase() {
  const TABS: TabType[] = [
    {
      label: "One item",
      href: "one",
      value: "one",
      children: (
        <>
          <TabOne />
        </>
      ),
    },
    {
      label: "Two item",
      href: "two",
      value: "two",
      children: (
        <>
          <TabOne />
        </>
      ),
    },
  ];
  const { tab } = Route.useParams();

  return (
    <>
      <AppTabList value={tab}>
        {TABS.map((item) => (
          <Tab
            key={item.value}
            label={item.label}
            value={item.value}
            component={Link}
            href={item.href}
            id={`tab-${item.value}`}
            aria-controls={`tabpanel-${item.value}`}
          />
        ))}
      </AppTabList>
      {TABS.map((item) => (
        <Box
          key={item.value}
          role="tabpanel"
          hidden={item.value !== tab}
          id={`tabpanel-${item.value}`}
          aria-labelledby={`tab-${item.value}`}
          sx={{ p: 3 }}
        >
          {item.value === tab && item.children}
        </Box>
      ))}
    </>
  );
}
